'use client';
import { AnimatePresence, motion } from 'framer-motion';
import { XYCHART_CROSSHAIR_COLOR, XYCHART_CROSSHAIR_DASH, } from './xychart-constants';
import type { XYChartLayout } from './xychart-types';
export interface XYChartCrosshairProps {
    layout: XYChartLayout;
    focusBand: number | null;
}
export function XYChartCrosshair({ layout, focusBand }: XYChartCrosshairProps) {
    return (
    <AnimatePresence>
      {focusBand != null && (<motion.line data-el="Cmarkdownxychart/Crosshair/Status" key="crosshair" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.12 }} x1={layout.horizontal ? 0 : focusBand} y1={layout.horizontal ? focusBand : 0} x2={layout.horizontal ? layout.plotWidth : focusBand} y2={layout.horizontal ? focusBand : layout.plotHeight} stroke={XYCHART_CROSSHAIR_COLOR} strokeWidth={1} strokeDasharray={XYCHART_CROSSHAIR_DASH} style={{ pointerEvents: 'none' }}/>)}
    </AnimatePresence>
    );
}
